<template>
    <div>
        <div>
            总共收入: {{ salary }} 元
        </div>
        <div class="echart1">
        </div>
    </div>
</template>
<script>
    import Url from '@/constant/Url'
    import $ from 'jquery'
    export default {
        data() {
            return {
                dataX:[],
                dataY:[],
                len:0,
                salary:0,
            }
        },
        mounted() {
            this.ReadSalary()
        },
        methods: {
            creatEchart(){
                let myChart=this.$echarts.init(document.querySelector('.echart1'))
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: this.dataY,
                        axisLabel: {
                            interval: this.len, // 设置显示间隔为2，显示五个点（间隔数 + 1）
                        },
                    },
                    yAxis: {
                        type: 'value'
                    },
                    tooltip: {
                        trigger: 'axis', // 设置 tooltip 触发方式为坐标轴触发
                        formatter: function (params) {
                            return params[0].name + ': ' + params[0].value; // 定制 tooltip 显示内容
                        },
                    },
                    series: [{
                        data: this.dataX,
                        type: 'line',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(220, 220, 220, 0.8)'
                        }
                    }]
                })
                window.addEventListener('resize',function(){
                    myChart.resize()
                })
            },
            ReadSalary() {
                const vue = this
                
                $.ajax({
                    url: Url.rOrdersSalaryUrl,
                    type: 'post',
                    success(resp) {
                        if (resp.error_message === "success") {
                            const arr = JSON.parse(resp.list)
                            console.log(arr)
                            
                            for (let i = 0; i < arr.length; i ++ ) {
                                vue.dataX.push(arr[i].total)
                                vue.dataY.push(arr[i].payTime)
                                vue.salary += arr[i].total
                            }
                            vue.len = parseInt(arr.length / 5 )
                            vue.creatEchart()
                        }
                    }
                })
            },
        },
        watch: {
            
        },
    }
</script>
<style  scoped>
.echart1{
    width: 1180px;
    height: 500px;
    margin: 0 auto;

}
</style>
